import { AuthUser } from '../types/user.interface';

export const getUserId = (user: AuthUser) => user?.sub.replace('auth0|', '');
